import { t } from 'i18next';
import { Link } from 'react-router-dom';

import { formatUtils } from '@/lib/utils';
import { AdminHealthOrphanRuns } from '@activepieces/shared';

import { CLIENTS_ROUTE } from './constants';

const STATUS_QUERY_PARAM = 'status';

// Lands on the client's executions tab already filtered on the stuck
// statuses, which is where the remediation (cancelling them) starts.
const clientExecutionsLink = (tenantId: string, statuses: string[]): string => {
  const query = new URLSearchParams(
    statuses.map((status) => [STATUS_QUERY_PARAM, status]),
  );
  return `${CLIENTS_ROUTE}/${tenantId}/executions?${query.toString()}`;
};

// The list only: it lives inside the "Orphan runs" tile, which expands rather
// than spawning a second card beside it.
export const OrphanRunLines = ({
  orphanRuns,
}: {
  orphanRuns: AdminHealthOrphanRuns;
}) => {
  const statuses = Object.keys(orphanRuns.byStatus);

  return (
    <div className="flex flex-col gap-2 px-4 py-3.5 border-t text-sm">
      {orphanRuns.total === 0 ? (
        <p className="text-muted-foreground">
          {t('Every run reached a final status.')}
        </p>
      ) : (
        <>
          <p className="text-xs text-muted-foreground">
            {statuses
              .map((status) =>
                t('{status}: {total}', {
                  status,
                  total: formatUtils.formatNumber(orphanRuns.byStatus[status]),
                }),
              )
              .join(' · ')}
          </p>
          {orphanRuns.topTenants.map((tenant) => (
            <Link
              key={tenant.tenantId}
              to={clientExecutionsLink(tenant.tenantId, statuses)}
              className="flex items-baseline justify-between gap-3 hover:underline"
            >
              <span className="truncate">{tenant.tenantName}</span>
              <span className="font-medium tabular-nums">
                {formatUtils.formatNumber(tenant.total)}
              </span>
            </Link>
          ))}
        </>
      )}
    </div>
  );
};
